

export default class CustomerDto {
	constructor(customer) {
		customer = customer || {};
		this.code = customer.code;
		this.customerCategory = CUSTOMER_CATEGORY;
		this.customerBrand = CUSTOMER_BRAND;
		this.seller = customer.enseigne || customer.seller || "";
		this.vatNo = customer.vatNo;
		this.registrationNo = customer.registrationNo;
		this.contactInformation = !!customer.mobile || customer.phone ? {
            email: customer.email || "",
            phone: customer.phone || "",
            mobile: customer.mobile
        } : {};

	}
}



// WEBPACK FOOTER //
// ./src/opencell/model/account/CustomerDto.js